import React from 'react';
import { TaskStatus } from './taskWorkflow';
import { trimmedNote } from './taskTree';

const noteClass = 'text-xs font-normal mt-0.5 max-w-[16rem]';

const SubtaskReviewNotes = ({ subtask }) => {
  if (!subtask) return null;

  const submit = trimmedNote(subtask.submitReason);
  const returned = trimmedNote(subtask.returnReason);
  const rejected = trimmedNote(subtask.rejectReason);
  const notes = [];

  if (subtask.waived) {
    notes.push({
      className: 'text-amber-700',
      text: `Waived${trimmedNote(subtask.waiveReason) ? `: ${trimmedNote(subtask.waiveReason)}` : ''}`
    });
  }

  if (subtask.status === TaskStatus.IN_PROGRESS && returned) {
    notes.push({ className: 'text-amber-800', text: `Returned: ${returned}` });
  }

  if (subtask.status === TaskStatus.UNDER_REVIEW) {
    if (returned) {
      notes.push({ className: 'text-amber-800', text: `Previously returned: ${returned}` });
    }
    if (submit) {
      notes.push({ className: 'text-[#346C75]', text: `Submitted: ${submit}` });
    }
  }

  if (subtask.status === TaskStatus.CANCELLED && rejected) {
    notes.push({ className: 'text-rose-700', text: `Rejected: ${rejected}` });
    if (submit) {
      notes.push({ className: 'text-gray-600', text: `Submitted: ${submit}` });
    }
  }

  if (notes.length === 0) return null;

  return (
    <>
      {notes.map((note) => (
        <div key={note.text} className={`${noteClass} ${note.className}`}>
          {note.text}
        </div>
      ))}
    </>
  );
};

export default SubtaskReviewNotes;
